import styled from 'styled-components';
import { Breakpoints, FontWeight } from '../../../styled/constants';
import { globalSystemColors } from '../../../styled/theme/constants';

export const TopWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  max-height: 700px;
  overflow: hidden;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    max-height: 520px;
  }
`;

export const SliderTrack = styled.div<{ translate: number }>`
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  transition: transform 0.6s ease;
  will-change: transform;
  transform: translateX(${({ translate }) => `${translate}%`});
`;

export const Slide = styled.div<{ background: string }>`
  flex: 0 0 100%;
  position: relative;
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  backface-visibility: hidden;
  transform: translateZ(0);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
    z-index: 2;
  }
`;

export const MainContent = styled.div`
  max-width: ${Breakpoints.desktop}px;
  height: 100%;
  margin: 0 auto;
  position: relative;
`;

export const ContentWrapper = styled.div`
  height: 100%;
  position: relative;

  @media (max-width: ${Breakpoints.desktop}px) {
    padding: 0 40px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    width: 100%;
    padding: 15px;
  }
`;

export const Content = styled.div`
  position: absolute;
  bottom: 110px;
  left: 0;
  z-index: 3;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    bottom: 60px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    bottom: 45px;
  }
`;

export const Title = styled.p`
  font-size: 50px;
  font-weight: ${FontWeight.medium};
  margin: 0 0 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.p`
  font-size: 25px;
  margin: 0 0 20px;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    font-size: 16px;
  }
`;

export const Button = styled.button`
  background-color: ${({ theme }) => theme.colors.text.primary};
  color: ${({ theme }) => theme.colors.background.primary};
  border: none;
  border-radius: 14px;
  padding: 16px 30px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.systemColors.blue};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

export const ArrowWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 110px;
  z-index: 3;
  display: flex;
  gap: 16px;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const Arrow = styled.button<{ right?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  &::before {
    content: '';
    width: 16px;
    height: 16px;
    background-image: url('/static/images/pasha/swipe-icon.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    transform: ${({ right }) => (right ? 'rotate(180deg)' : 'none')};
  }
`;

export const Indicators = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  gap: 8px;
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  z-index: 3;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    bottom: 25px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    bottom: 5px;
  }
`;

export const Indicator = styled.div<{ active: boolean; autoPlay: boolean }>`
  flex-grow: ${({ active }) => (active ? 2 : 1)};
  height: 5px;
  border-radius: 10px;
  background-color: ${({ active, theme, autoPlay }) =>
    active && !autoPlay
      ? theme.colors.text.primary
      : 'rgba(225, 225, 225, 0.5)'};
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  .progress {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.text.primary};
    animation: progressAnim 10s linear forwards;
    border-radius: inherit;
    pointer-events: none;
  }

  &:hover {
    background: rgba(225, 225, 225, 0.8);
  }

  @keyframes progressAnim {
    from {
      width: 0%;
    }
    to {
      width: 100%;
    }
  }
`;

export const SliderLink = styled.a`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.text.primary};
  color: ${globalSystemColors.cocoaBrown};
  border-radius: 14px;
  padding: 16px 30px;
  font-size: 16px;
  text-decoration: none;
  font-weight: 500;
`;
